import { jsx as o } from "react/jsx-runtime";
import { SvgIcon as t } from "../SvgIcon.js";
const m = (r) => /* @__PURE__ */ o(t, { ...r, children: /* @__PURE__ */ o("path", { d: "M13.7649 10.6185H10.635v3.1382H9.38133v-3.1382H6.2514V9.37318h3.12993V6.24326H10.635v3.12992h3.1299v1.24532Z" }) });
export {
  m as PlusMath
};
//# sourceMappingURL=PlusMath.js.map
